import React, { useCallback, useMemo, useRef,useState } from "react";
import {
  Button,
  FormCheckbox
} from "shards-react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import CustomPagination from "../common/CustomPagination";
import Pagination from '../common/Pagination';
import Dropdown from "react-bootstrap/Dropdown";
import authStore from "../../_stores/auth.store";
// import { AgGridColumn, AgGridReact } from 'ag-grid-react';

// import 'ag-grid-community/dist/styles/ag-grid.css';
// import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

// const perPage = 5;
let PageSize = 5;

const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const INDIA = process.env.REACT_APP_MARKET === "INDIA";

export default function ReportTable({
  ReportData,
  selectedReport,
  reportSelected,
  processFile,
  cancelProcessFile,
  uploadFileById,
  processSASFileById,
  viewRawFile,
  viewOriginalFile,
  container_classlist = [],
  hasAction = false,
  tab,
  checkboxChecked,
  handleFieldCount,
  deleteFileById,
  processFileByIdQueue,
  downloadConversionFile,
  uploadConversionFile,
  goToReport,
  addToQueue,
  skipAndProcess,
  reDownloadFile,
  downloadFileById,
  downloadRawFile,
  uploadFileToDB
}) {
   const [pagedReport, set_pagedReport] = useState([]);
   const container_classes = container_classlist.join(" ");

   const [currentPage, setCurrentPage] = useState(1);

    const currentTableData = useMemo(() => {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return ReportData.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, ReportData]);

  function handleFieldCount(e, selectedName){
    ReportData.map(item => {
      if(item._id === selectedName) {
        item.checked = item.checked ? !item.checked : true;
      }
    });

    checkboxChecked(ReportData);
  }
  
  //var frameworkComponents= { actionComponent: ActionComponent };
  return (
    <div className={container_classes}>

      <Table className="table theme-01 border-bottom" size="sm" responsive>
        <thead className="bg-light">
          <tr>
            <th scope="col" className="border-0">
              Select
            </th>
            <th scope="col" className="border-0">
              Supplier Code
            </th>
            <th scope="col" className="border-0">
              Batch
            </th>
            <th scope="col" className="border-0">
              File Type
            </th>
            <th scope="col" className="border-0">
              File Name
            </th>
            <th scope="col" className="border-0">
              Year-Month
            </th>
            <th scope="col" className="border-0">
              Time Log
            </th>
            <th scope="col" className="border-0">
              Step
            </th>
            <th scope="col" className="border-0 custom-width">
              Status Text
            </th>
            <th scope="col" className="border-0 custom-width">
              Transaction Count
            </th>
            {/* <th scope="col" className="border-0">
              Status Description
            </th> */}
            
            {/* <th scope="col" className="border-0">
              File Type
            </th> */}
            {hasAction ? (
              <th scope="col" className="border-0">
                Action
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {currentTableData.length ? (
            currentTableData.map((item, index) => {
              const classList = ["clickable"];
              if (item._id === selectedReport._id) classList.push("selected");
              let disabled = false;
              
              if(processFileByIdQueue && processFileByIdQueue.indexOf(item.supplierCode) > -1) {
                disabled = true;
              } else {
                disabled = false;
              }
              switch (item.step.toLowerCase()) {
                case "downloaded":
                  classList.push("downloaded");
                  break;
                case "process":
                case "validation":
                  classList.push("validation");
                  break;
                // case "process":
                //   classList.push("process");
                //   break;
                case "cancelled":
                case "complete":
                  classList.push("complete");
                  break;
                case "conversion":
                  classList.push("conversions");
                  break;
                case "conversion_added":
                  classList.push("conversion_added");
                  break;
                case "failed":
                  classList.push("failed");
                  break;
                case "uploaded":
                  classList.push("uploaded");
                  break;
                default:
                  console.info("Default case in report table row.");
              }

              return (
                <tr className={classList.join(" ")} key={index.toString()} onClick={() => reportSelected(item)}>
                  <td>
                    <FormCheckbox key={index+1} className="mb-1" 
                        name={"count_"+item._id} id={"count_"+item._id} 
                        checked={item.checked}
                        onChange={e => handleFieldCount(e, item._id)}
                    / >
                  </td>
                  <td>{item.supplierCode}</td>
                  <td>{item._id}</td>
                  <td>{item.fileType}</td>
                  <td>{item.fileName}</td>
                  <td>{item.year}-{item.month}</td>
                  <td>{moment(new Date(item.updatedAt)).format("DD/MM/yyyy hh:mm:ss A")}</td>
                  <td>{item.step}</td>
                  <td>{item.statustxt}</td>
                  <td>{item.transactionCount}</td>
                  {/* <td>{item.statusDescription && item.statusDescription.substring(0, 1000)}</td> */}
                  
                  {/* <td>{item.fileMetadata}</td> */}
                  {hasAction ? (
                    <td>
                      <ActionComponent
                        processFile={() => processFile(item._id, item.supplierCode)}
                        cancelProcessFile={() => cancelProcessFile(item._id, item.supplierCode)}
                        viewRawFile={() => viewRawFile(item._id, item.supplierCode)}
                        reDownloadFile={() => reDownloadFile(item._id, item.supplierCode)}
                        viewOriginalFile={() => viewOriginalFile(item._id, item.supplierCode)}
                        uploadFileById={() => uploadFileById(item._id, item.supplierCode)}
                        processSASFileById={() => processSASFileById(item._id, item.supplierCode)}
                        deleteFileById={() => deleteFileById(item._id, item.supplierCode)}
                        downloadConversionFile={() => downloadConversionFile(item._id, item)}
                        uploadConversionFile={() => uploadConversionFile(item._id, item)}
                        goToReport={() => goToReport(item._id, item)}
                        addToQueue={() => addToQueue(item._id, item)}
                        skipAndProcess={() => skipAndProcess(item._id, item)}
                        downloadFileById={() => downloadFileById(item._id,item.month,item.year)}
                        downloadRawFile={() => downloadRawFile(item._id, item)}
                        uploadFileToDB={() => uploadFileToDB(item._id, item.supplierCode)}
                        tab={tab}
                        disabled={disabled}
                      />
                    </td>
                  ) : null}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                No Data
              </td>
            </tr>
          )}
        </tbody>
      </Table>



      <div className="flx-content-right">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={ReportData.length}
          pageSize={PageSize}
          onPageChange={page => setCurrentPage(page)}
        />
        {/* <CustomPagination data={ReportData} setData={set_pagedReport} pageSize={5} /> */}
      </div>
    </div>
  );
}



function ActionComponent({ processFile, cancelProcessFile, viewRawFile, reDownloadFile, viewOriginalFile, uploadFileById, processSASFileById, deleteFileById, downloadConversionFile, uploadConversionFile, goToReport, addToQueue, skipAndProcess, downloadFileById, downloadRawFile, uploadFileToDB, tab, disabled }) {
  //alert()

  //console.log("ActionComponent.tab", tab);

  return (
    <>
     <Dropdown className="drpdwn-thm-1">
      <Dropdown.Toggle as="button" className="btn" id="drp-toggle"></Dropdown.Toggle>
       <Dropdown.Menu>
        {(tab !== "uploaded" && tab !== "conversion" && tab !== "conversion_added") && (
          <>
            {!INDIA && tab !== "complete" && (
              <Dropdown.Item as="button" className="btn" onClick={processFile} disabled={disabled}>
              Process
            </Dropdown.Item>
           )}
           {INDIA && (
              <Dropdown.Item as="button" className="btn" onClick={processFile} disabled={disabled}>
              Process
            </Dropdown.Item>
           )}
           {INDIA && (
            <Dropdown.Item as="button" className="btn" onClick={processSASFileById} disabled={disabled}>
              Process Only SAS
            </Dropdown.Item>
           )}
          </>
        )}
        {(tab === "conversion") && (
          <>
            <Dropdown.Item as="button" className="btn" onClick={goToReport}>
              Go To Report
            </Dropdown.Item>
            <Dropdown.Item as="button" className="btn" onClick={processFile}>
              Re-Process
            </Dropdown.Item>
            <Dropdown.Item as="button" className="btn" onClick={downloadConversionFile} disabled={disabled}>
             Download Conv
           </Dropdown.Item>
           <Dropdown.Item as="button" className="btn" onClick={uploadConversionFile} disabled={disabled}>
             Upload Conv
           </Dropdown.Item>
          </>
        )}
        {(tab === "conversion_added") && (
          <>
            <Dropdown.Item as="button" className="btn" onClick={processFile}>
             Re-Process
            </Dropdown.Item>
            <Dropdown.Item as="button" className="btn" onClick={uploadFileById} disabled={disabled}>
              Upload
            </Dropdown.Item>
          </>
        )}
        {(tab === "complete" || tab === "failed") && (
          <>
            {(INDIA || SAUDI) && (
              <Dropdown.Item as="button" className="btn" onClick={uploadFileById} disabled={disabled}>
                Upload
              </Dropdown.Item>
           )}
           {(SAUDI || SPAIN) && (
            <>
              <Dropdown.Item as="button" className="btn" onClick={processFile}>
                Re-Process
              </Dropdown.Item>
            </>
           )}
           {(SAUDI) && (
            <>
              <Dropdown.Item as="button" className="btn" onClick={uploadFileToDB} disabled={disabled}>
                Upload To DB
              </Dropdown.Item>
            </>
           )}
          
           </>
        )}
        {(tab !== "uploaded") && (
          <>
            {(INDIA || SPAIN) && (
            <Dropdown.Item as="button" className="btn" onClick={cancelProcessFile} disabled={disabled}>
              Cancel
            </Dropdown.Item>
            )}
          </>
        )}
        {(tab === "uploaded") && (
          <>
           <Dropdown.Item as="button" className="btn" onClick={processFile}>
             Re-Process
           </Dropdown.Item>
           <Dropdown.Item as="button" className="btn" onClick={uploadFileById}>
             Re-Upload
           </Dropdown.Item>
           <Dropdown.Item as="button" className="btn" onClick={cancelProcessFile}>
             Cancel
           </Dropdown.Item> 
          </>
        )}
        {(tab === "downloaded" || tab === "validation") && (
          (authStore.getState().auth_reducer.user.role === "superadmin" || authStore.getState().auth_reducer.user.role === "admin") && (
            <>
            
              <Dropdown.Item as="button" className="btn" onClick={deleteFileById} disabled={disabled}>
                Delete
              </Dropdown.Item>
            
            </>
          )
        )}
        {(tab === "validation" && INDIA) && (
          <Dropdown.Item as="button" className="btn" onClick={skipAndProcess} disabled={disabled}>
             Skip And Process
          </Dropdown.Item>
        )}
        {(SPAIN) && (
          <>
            <Dropdown.Item as="button" className="btn" onClick={reDownloadFile} disabled={disabled}>
              Re-Download
            </Dropdown.Item>
          </>
        )}
        {(tab === "complete") && (
          <>
            {(SPAIN) && (
              <Dropdown.Item as="button" className="btn" onClick={downloadFileById} disabled={disabled}>
                Export
              </Dropdown.Item>
            )}
          </>
          
        )}

        {SAUDI && (
          <Dropdown.Item as="button" className="btn" onClick={downloadRawFile}>
              Raw File Download
          </Dropdown.Item>
        )}


        {/* <Dropdown.Item as="button" className="btn" onClick={cancelProcessFile}>
            Cancel
        </Dropdown.Item>  */}
      </Dropdown.Menu>
    </Dropdown>
    </>
  );
}
